import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate/dist/types/components/Observer.d";

@Component
export default class HasValidation extends Vue {
  public observer = {} as InstanceType<typeof ValidationObserver>;
  public failSilentIfObserverNotFound = false;
  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  public mounted(): void {
    this.$nextTick(() => {
      this.setValidationObserver();
    });
  }

  public getForm(vue) {
    if (!vue) return {};
    return this.$_.isEmpty(vue.$refs.observer)
      ? this.getForm(vue.$parent)
      : vue.$refs.observer;
  }

  public setValidationObserver() {
    const observer = this.getForm(this);
    if (this.$_.isEmpty(observer) && !this.failSilentIfObserverNotFound)
      throw new Error("ValidationObserver not found!");
    this.observer = observer;
  }

  public validate(silent = false) {
    if (this.$_.isEmpty(this.observer))
      throw new Error("ValidationObserver not found!");
    return this.observer.validate({ silent });
  }

  public get validationErrors() {
    return this.$_.isEmpty(this.observer) ? {} : this.observer.errors;
  }

  public get hasErrors() {
    let hasErrors = false;
    this.$_.forEach(this.validationErrors, error => {
      hasErrors = error.length !== 0;
      if (hasErrors) {
        return false;
      }
    });
    return hasErrors;
  }

  public clearErrors() {
    this.$_.forEach(this.validationErrors, (error, key) => {
      this.validationErrors[key] = [];
    });
  }

  public hasError(key) {
    return !this.$_.isEmpty(this.getError(key));
  }

  public getError(key) {
    return this.$_.get(this.validationErrors, key, []);
  }

  public getFirstError(key) {
    return this.getError(key)[0];
  }

  public removeError(key) {
    if (!this.$_.has(this.validationErrors, key)) return;
    this.validationErrors[key] = [];
  }
}
